import React from "react";
import "./spinner.css";

export const Spinner = ({
  primaryColor = "var(--bg-brand-default)",
  secondaryColor = "var(--bg-neutral-layer01)",
  size = 24,
  thickness = 3,
  style = {},
  className = "",
}) => {
  return (
    <div
      className={`spinnerComponent ${className}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        ...style,
      }}
    >
      <div
        className="spinner__circle"
        style={{
          borderWidth: `${thickness}px`,
          borderColor: `${primaryColor} ${secondaryColor} ${secondaryColor}`,
        }}
      ></div>
    </div>
  );
};